<div class="container">
    @if (!data.hasId()) {
        <h2 mat-dialog-title class="cut-long-text">Neuer Datensatz</h2>
    } @else {
        <h2 mat-dialog-title class="cut-long-text">Datensatz bearbeiten</h2>
    }
    <mat-divider></mat-divider>
    <form [formGroup]="formGroup">
        <mat-dialog-content>
            <br />
            <mat-form-field appearance="outline">
                <mat-label>Fach/Beruf</mat-label>
                <input
                    matInput
                    type="text"
                    required
                    placeholder=""
                    formControlName="name"
                />
                <mat-error>{{
                    checkForErrors(formGroup.controls["name"])
                }}</mat-error>
            </mat-form-field>
            <br />
            <mat-form-field appearance="outline">
                <mat-label>Region</mat-label>
                <mat-select formControlName="region">
                    <mat-option value="-1">Keine Region</mat-option>
                    @for (country of countries; track country) {
                        <mat-option value="{{ country }}">{{
                            country
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </mat-dialog-content>
    </form>
    <mat-divider></mat-divider>

    <mat-dialog-actions>
        <button mat-raised-button (click)="onCancel()">Abbruch</button>
        <button
            mat-raised-button
            (click)="onSave()"
            [disabled]="
                !formGroup.valid || formGroup.controls['name'].value === ''
            "
        >
            Speichern
        </button>
    </mat-dialog-actions>
</div>
